import React, { useEffect, useState } from 'react';
import Sidebar from '../../components/Sidebar';
import Topbar from '../../components/Topbar';
// import SearchBar from '../../components/SearchBar';
// import Filters from '../../components/Filters';
import ProjectCard from '../../components/ProjectCard';
import Pagination from '../../components/Pagination';
import { getProposals } from '../../services/mockProposals';
import api from '../../../services/api';
import { Link } from 'react-router-dom';

export default function ProposalsIndex(){
  const [q, setQ] = useState('');
  // Status filter temporarily disabled — preserved for future use
  // const [status, setStatus] = useState('Todos');
  const [view, setView] = useState('grid');
  const [page, setPage] = useState(1);
  const [data, setData] = useState({ items: [], total: 0 });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const perPage = 12;

  useEffect(() => {
    let mounted = true;
    async function load() {
      setLoading(true);
      setError(null);
      try {
        // Temporarily not sending status to the fetcher
        const res = await getProposals({ page, perPage, q });
        if (mounted) {
          setData(res);
          try { console.log('Index: getProposals result', res); } catch (e) {}
        }
      } catch (err) {
        if (mounted) setError(err.message || 'Erro ao carregar orçamentos');
      } finally {
        if (mounted) setLoading(false);
      }
    }
    load();
    return () => (mounted = false);
  }, [page, q]);

  // Debug fetch: request last 10 proposals directly from backend and log them
  useEffect(() => {
    (async () => {
      try {
        const res = await api.get('/proposals', { params: { page: 1, perPage: 10 } });
        try { console.log('DEBUG: last 10 proposals from backend', res.data); } catch (e) {}
      } catch (err) {
        try { console.log('DEBUG: failed to fetch last 10 proposals from backend', err); } catch (e) {}
      }
    })();
  }, []);

  function handleRetry() {
    setError(null);
    setLoading(true);
    getProposals({ page, perPage, q }).then(res => { setData(res); setLoading(false); }).catch(err => { setError(err.message || 'Erro'); setLoading(false); });
  }

  return (
    <div className="flex bg-gray-50 min-h-screen">
      <Sidebar />
      <div className="flex-1">
        <Topbar user={{ name: 'Mateus Teixeira', role: 'Administrador' }} />

        <main className="p-6 max-w-7xl mx-auto">
          <div className="flex items-center justify-between mb-6">
            <div className="translate-y-2">
              <h2 className="text-2xl font-bold -translate-y-1">Orçamentos</h2>
              <p className="mt-6 text-sm text-gray-500">Gerencie e acompanhe todos os seus orçamentos.</p>
            </div>
            <div className="flex items-center gap-3">
              {/* <SearchBar value={q} onChange={setQ} /> */}
              <Link to="/system/proposals/new" className="px-4 py-2 bg-purple-600 text-white rounded-2xl">+ Novo Orçamento</Link>
            </div>
          </div>

            <div className="mb-4">
            {/* Status filter UI temporarily disabled — keep props for future use */}
            {/* <Filters view={view} setView={setView} /> */}
          </div>

            {error && (
              <div className="mb-4 p-4 bg-red-50 text-red-700 rounded-lg flex items-center justify-between">
                <div>Erro ao carregar orçamentos: {error}</div>
                <button onClick={handleRetry} className="ml-4 px-3 py-1 bg-red-100 text-red-700 rounded">Tentar novamente</button>
              </div>
            )}

            {loading && data.items.length === 0 && (
              <div className="py-12 text-center text-gray-500">Carregando orçamentos...</div>
            )}

          <div className={view==='grid' ? 'grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6' : 'space-y-4'}>
            {(data.items || []).length === 0 && !loading ? (
              <div className="col-span-full text-center text-gray-500 py-12">Nenhum orçamento encontrado.</div>
            ) : (
              (data.items || []).map(p => (
                <ProjectCard key={p.id} p={p} view={view} />
              ))
            )}
          </div>

          <Pagination page={page} setPage={setPage} total={data.total} perPage={perPage} />
        </main>
      </div>
    </div>
  );
}
